﻿// example from https://davidwalsh.name/pubsub-javascript
export const eventBus = (() => {

    var topics = {};

    var subscribe = function (topic, listener) {
        if (!topics.hasOwnProperty.call(topics, topic)) {
            topics[topic] = [];
        }
        topics[topic].push(listener);
    };

    var unsubscribe = function (topic) {
        delete topics[topic];
    };

    // fire the subscribed event
    var publish = function (topic, options) {
        // manages event queue
        if (!topics.hasOwnProperty.call(topics, topic)) {
            return;
        }

        topics[topic].forEach(function (item) {
            item(options != undefined ? options : {});
        });
    };

    return {
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        publish: publish
    };
})();